<template>
  <div class="activity-product-card-layout-experiment">
    <div class="top-section">
      <slot name="top-section" />
      <slot name="top-section-tag" />
      <slot name="trash-icon" />
    </div>
    <div class="bottom-section">
      <div class="content">
        <slot name="content" />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.activity-product-card-layout-experiment {
  display: grid;
  grid-auto-rows: auto;

  border-radius: var(--border-radius-8);
  border: 1px solid var(--color-neutral-30);
  background-color: var(--color-white);
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: relative;
  gap: var(--spacing-12);

  .top-section {
    width: 100%;
    min-width: 0;
    height: auto;
    overflow: hidden;
    position: relative;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-width: 0;
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);

    .content {
      border-bottom: unset;
      border-bottom-left-radius: unset;
      flex: 1;
    }

    .footer {
      border: unset;
      padding-bottom: var(--spacing-16);
    }
  }
}
</style>
